module.exports = __webpack_public_path__ + "static/img/6.c0dd868.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/6.png
// module id = 1pHe
// module chunks = 0